import {Injectable} from '@angular/core';
import {Actions} from '@ngrx/effects';
import {ShiftService} from '@app/modules/shared/services/shift.service';

@Injectable()
export class LayoutEffects {

	/*@Effect()
	 public onGetLayout$ = this.actions$.pipe(
	 ofType<GetShifts>(ELayoutActions.GetShifts),
	 switchMap((action: GetShifts) => from(this.shiftService.getShifts({start_date: action.start_date, end_date: action.end_date})).pipe(
	 switchMap((shifts: GetShiftsResponse) => [
	 new GetShiftsSuccess(shifts.shifts),
	 ]),
	 catchError(error => of(new LoadError(error, action))),
	 )),
	 );*/

	constructor(
		private actions$: Actions,
		private shiftService: ShiftService
	) {
	}
}
